import { Block, VerticalFormGroup } from 'components/secondaryMarket/shared';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { FC } from 'react';

const fieldIds: string[] = ['xMarginPlusUpfront', 'tradingPrice', 'salesMargin'];

export type SalesMarginInformationProps = Readonly<{
  tabId: string;
  className?: string;

  upfront: number | undefined;
  upFrontReadOnly?: boolean;
  salesMarginAdjusted: number | undefined;
  tradingPriceAdjusted: number | undefined;
  amountUnit: string;
  isFrozen: boolean;

  onTradingPriceChanged: (value: number | undefined) => void;
  onSalesMarginChanged: (value: number | undefined) => void;
  onUpFrontChanged: (value: number | undefined) => void;
}>;

export const LiveSalesMarginInformationMargin: FC<SalesMarginInformationProps> = ({
  className,
  isFrozen,
  upfront,
  upFrontReadOnly,
  tradingPriceAdjusted: tradingPrice,
  salesMarginAdjusted: salesMargin,
  amountUnit,
  onTradingPriceChanged,
  onSalesMarginChanged,
  onUpFrontChanged,
}) => {
  return (
    <Block
      className={className}
      label="secondaryMarket.saleMarginInformation.label.title"
      id="sales-margin-information"
      fieldIds={fieldIds}
    >
      <div>
        <div className="row">
          <VerticalFormGroup
            inputId="customizedUpfront"
            label="secondaryMarket.saleMarginInformation.upfront"
            className="col-md-3"
          >
            <AmountWithUnit
              id="customizedUpfront"
              value={upfront}
              onBlur={onUpFrontChanged}
              unit={amountUnit}
              e2e="upfront"
              precision={4}
              isReadOnly={upFrontReadOnly}
              isDisabled={isFrozen && !upFrontReadOnly}
            />
          </VerticalFormGroup>

          <VerticalFormGroup
            inputId="customizedTradingPriceAdjustment"
            label="secondaryMarket.saleMarginInformation.tradingPriceAdjusted"
            className="col-md-4"
          >
            <AmountWithUnit
              id="customizedTradingPriceAdjustment"
              value={tradingPrice}
              onBlur={onTradingPriceChanged}
              unit={amountUnit}
              precision={4}
              e2e="tradingPriceAdjusted"
              isDisabled={isFrozen}
            />
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="customizedXMarginAdjustment"
            label="secondaryMarket.saleMarginInformation.salesMarginAdjusted"
            className="col-md-5"
          >
            <AmountWithUnit
              id="customizedXMarginAdjustment"
              value={salesMargin}
              onBlur={onSalesMarginChanged}
              unit={amountUnit}
              e2e="salesMarginAdjusted"
              isDisabled={isFrozen}
              precision={4}
            />
          </VerticalFormGroup>
        </div>
      </div>
    </Block>
  );
};

LiveSalesMarginInformationMargin.displayName = 'LiveSalesMarginInformationMargin';
